import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { SlidersHorizontal, Calculator } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/site/motion";
import Seo from "@/components/site/Seo";
import Configuratore from "@/components/site/Configuratore";
import Simulatore from "@/components/site/Simulatore";
import { IMAGES } from "@/data/content";

export default function Preventivo() {
    const { t } = useLang();
    const p = t.preventivoPage;
    const params = new URLSearchParams(useLocation().search);
    const [tab, setTab] = useState(params.get("tab") === "sim" ? "sim" : "config");

    const tabs = [
        { key: "config", label: p.tabConfig, icon: SlidersHorizontal },
        { key: "sim", label: p.tabSim, icon: Calculator },
    ];

    return (
        <div data-testid="preventivo-page">
            <Seo title={t.seo.preventivo.t} description={t.seo.preventivo.d} image={IMAGES.hero} path="/preventivo" />

            <section className="relative pt-40 pb-20 bg-cb-dark cb-grid overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <img src={IMAGES.cta} alt="" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-cb-darker/80" />
                </div>
                <div className="relative max-w-7xl mx-auto px-6">
                    <Reveal className="text-cb-accent text-xs uppercase tracking-[0.3em] mb-4">{p.chapter}</Reveal>
                    <Reveal as="h1" delay={0.3} className="font-display text-5xl md:text-6xl font-bold tracking-tighter text-white">{p.title}</Reveal>
                    <Reveal delay={0.6} className="mt-6 max-w-2xl text-slate-300 text-lg">{p.sub}</Reveal>
                </div>
            </section>

            <section className="py-16 md:py-24 bg-white">
                <div className="max-w-5xl mx-auto px-6">
                    {/* Tabs */}
                    <div className="flex flex-col sm:flex-row gap-3 mb-12">
                        {tabs.map((tb) => {
                            const Icon = tb.icon;
                            const activeTab = tab === tb.key;
                            return (
                                <button
                                    key={tb.key}
                                    data-testid={`prev-tab-${tb.key}`}
                                    onClick={() => setTab(tb.key)}
                                    className={`flex-1 inline-flex items-center justify-center gap-2 px-6 py-4 border font-medium transition-colors ${
                                        activeTab ? "bg-cb-dark text-white border-cb-dark" : "border-slate-300 text-slate-600 hover:border-cb-accent hover:text-cb-accent"
                                    }`}
                                >
                                    <Icon size={18} /> {tb.label}
                                </button>
                            );
                        })}
                    </div>

                    <div className="border border-slate-200 p-6 sm:p-10">
                        {tab === "config" ? <Configuratore /> : <Simulatore />}
                    </div>
                </div>
            </section>
        </div>
    );
}
